<mat-toolbar class="content-header">
    <h1 class="page-title">
        <mat-icon>edit</mat-icon>
        {{'settings.project.editTag' | translate}}
        <!-- <app-help [link]="helpLink" class="helper-margin"></app-help> -->
    </h1>

    <span class="toolbar-spacer"></span>
</mat-toolbar>

<div class="content-container">
    <div class="button-group">
        <lib-button class="tag-button" (click)="module = 'crane'"
            icon="precision_manufacturing" text="{{'settings.project.tags_crane' | translate}}"
            [color]="module == 'crane' ? 'primary' : 'outline'" size="medium">
        </lib-button>

        <lib-button class="tag-button" (click)="module = 'risk'" icon="warning"
            text="{{'settings.project.tags_risk' | translate}}" [color]="module == 'risk' ? 'primary' : 'outline'"
            size="medium">
        </lib-button>
    </div>

    <div class="tags-container">
        <app-prediction-tags [module]="module"></app-prediction-tags>
    </div>
</div>